import React from 'react'
import {Box} from '@mui/material'
import { Footer, Hero } from '../components';
import {
  ContactForm,
  ContactHero,
  ContactInfo

} from '../containers'


//assets
import { ScrollReveal } from '../components'

const Contact = () => {


  return (
    <Box
      sx={{
        minHeight:'100vh',
      }}
    >
        <Hero />
        <ScrollReveal threshold={0.2}>
          <ContactForm />
        </ScrollReveal>
        <ScrollReveal>
          <ContactInfo />
        </ScrollReveal>
        <Box>

        </Box>
      <Footer />
    </Box>
  )
}

export default Contact